import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_SECURITY_MATRIX_DETAIL_OK = "GET_SECURITY_MATRIX_DETAIL_OK";
export const GET_SECURITY_MATRIX_DETAIL_ERR = "GET_SECURITY_MATRIX_DETAIL_ERR";

export const getSecurityMatrixDetailAction = {
  getSecurityMatrixDetail,
};

function getSecurityMatrixDetailOk(payload) {
  return { type: GET_SECURITY_MATRIX_DETAIL_OK, payload };
}
function getSecurityMatrixDetailErr(payload) {
  return { type: GET_SECURITY_MATRIX_DETAIL_ERR, payload };
}

function getSecurityMatrixDetail(data) {
  var param = "RoleId=" + data;
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetSecurityMatrixDetail, param)
      .then((response) => {
        dispatch(getSecurityMatrixDetailOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getSecurityMatrixDetailErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
